/* Angular Component */
import {
  Component,
  Input,
  ElementRef,
  ViewChild,
  ChangeDetectorRef,
  HostListener,
  SimpleChanges,
  OnInit,
  EventEmitter,
  Output,
  OnChanges,
  AfterViewInit,
} from "@angular/core";
import { UI } from "../../services/ui.service";
import { Subtitle } from "../../domain/subtitle";
import { SubtitleRepository } from "../../domain/subtitle-repository";
import { ChannelPlatformType } from "../../domain/enums";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { AudioRepository } from "../../domain/audio-repository";
import { Audio } from "../../domain/audio";
import { clearLine } from "readline";
import { ChannelRepository } from "../../domain/channel-repository";
import { UserService } from "../../domain/user-service";
import { ChannelInfo, CustomChannelPlatform } from "../../domain/channel";
import { Font } from "../../domain/font";
import { HttpService } from "../../infrastructure/http/http";
import { MediaInfo, MediaItem } from "../../domain/media";

const FULL_SCREEN_CLASS = "full-screen-video";
const SUBTITLES_THRESHOLD = 0.3; // the fudje factor

const RTL_SUBTITLES = {
  he: true,
  ar: true,
};

const HE_LETTERS = [
  "א",
  "ב",
  "ג",
  "ד",
  "ה",
  "ו",
  "ז",
  "ח",
  "ט",
  "י",
  "כ",
  "ך",
  "ל",
  "מ",
  "נ",
  "ן",
  "ס",
  "ע",
  "פ",
  "ף",
  "צ",
  "ק",
  "",
  "ץ",
  "ר",
  "ש",
  "ת",
];
const AR_LETTERS = [
  "ا",
  "ب",
  "پ",
  "ت",
  "ث",
  "ج",
  "چ",
  "ح",
  "خ",
  "د",
  "ذ",
  "ر",
  "ز",
  "ژ",
  "ص",
  "ض",
  "ط",
  "ظ",
  "ع",
  "غ",
  "ف",
  "ق",
  "ک",
  "گ",
  "ل",
  "م",
  "ن",
  "و",
  "ه",
  "ی",
];
const PUNCATUATIONS = [".", ",", "!", "?", ":", ";", "-", " "];
@Component({
  selector: "video-container",
  templateUrl: "./videoContainer.component.html",
  styleUrls: ["./videoContainer.component.scss"],
})
export class VideoContainerComponent
  implements OnInit, OnChanges, AfterViewInit
{
  seekPlayerToTimeSubscription: any;
  constructor(
    private element: ElementRef,
    private ui: UI,
    private subtitleRepository: SubtitleRepository,
    private changeDetectorRef: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private audioRepository: AudioRepository,
    private userService: UserService,
    private httpService: HttpService,
    private channelRepository: ChannelRepository,
  ) {
    ui.listen(
      ui.EVENTS.CloseVideoPreview,
      function () {
        if (this.playing) {
          this.getVideoElement().pause();
        }
      }.bind(this),
    );
  }

  @Input()
  media: MediaInfo;

  @Input()
  item;

  @Input()
  videoUrl;

  @Input()
  posterUrl;

  @Input()
  isAbsolute = true;

  @Input()
  audio;

  @Input()
  mediaDurationMs = 0;

  @Input()
  subtitles;

  @Input()
  closedCaptions;

  @Input()
  defaultSubtitleLanguage;

  @Input()
  startTime = 0;

  @Input()
  autoPlay = false;

  @Input()
  showTimecode = false;

  @Input()
  framerate = 0;

  @Input()
  subtitleOffsetMs = 0;

  @Input()
  showTrimBrackets: boolean;

  @Input()
  trimInMs = 0;

  @Output()
  trimInMsChange = new EventEmitter<number>();

  @Input()
  trimOutMs = 0;

  @Input()
  seekPlayerToTime: EventEmitter<number>;

  @Output()
  durationChange = new EventEmitter<number>();

  @Output()
  trimOutMsChange = new EventEmitter<number>();

  @Output()
  currentTimeMsChange = new EventEmitter<number>();

  frameDuration = 0;
  subtitleText: SafeHtml;
  subtitleIndex;
  subtitle;
  rtlSubtitle = false;
  selectedSubtitle: Subtitle;
  channelInfo: ChannelInfo = null;
  subtitlesStyle: {} = null;
  duration = 0;
  overDuration = 0;
  overDurationRule: string;
  overDurationTxt = 0;
  durationTooltipWidth: number = null;
  durationTooltipX = 0;
  durationTooltipVisible = false;
  @ViewChild("durationTooltip", { static: true })
  durationTooltip: ElementRef;
  timecodeValue = 0;
  timecodeInterval;
  timecodeFormatting = "ms";
  playing = false;
  ready = false;
  duringRecording = false;
  muted = false;

  audioOpen = false;
  subtitlesOpen = false;
  timecodeFormatOpen = false;
  isFullScreen = false;

  isVisible = true;
  onVideoOptions;

  isError = true;
  slowConnection = false;

  timer = null;

  /* audio track section */
  @ViewChild("audioTrack", { static: true })
  audioTrack: ElementRef;

  @ViewChild("durationElement")
  durationElement: ElementRef;

  shouldPlayAudioTrack = false;
  autoStopForAudioSync = false;

  lastTime = null;
  request = false;

  reference: any;

  trimBracketWidth = 10;

  durationProgressBarWidthPx = 0;

  calculatedTrinInOffset = 0;
  calculatedTrinOutOffset = 0;

  private trimInDragPosition = 0;
  private trimOutDragPosition = 0;

  private _trimInMouseUp = null;
  private _trimInMouseMove = null;

  private _trimOutMouseUp = null;
  private _trimOutMouseMove = null;

  whileTrimming = false;

  downloadFonts(): any {
    throw new Error("Method not implemented.");
  }
  /**
   * Detect Changes and performing actions according to it
   * @param changes
   * @return void
   */
  ngOnChanges(changes: SimpleChanges) {
    if (changes["audio"]) {
      if (this.audio && this.audio.length > 0) {
        this.audio.unshift(new Audio("DEFAULT").setDefaultAudio());
      }
    }
    if (changes["framerate"]) {
      this.calculateFrameDuration();
    }

    if (changes["trimOutMs"] || changes["trimInMs"]) {
      this.updateTrimming();
    }
    if (
      changes["seekPlayerToTime"] &&
      changes["seekPlayerToTime"].currentValue
    ) {
      if (this.seekPlayerToTimeSubscription) {
        this.seekPlayerToTimeSubscription.unsubscribe();
      }
      this.seekPlayerToTimeSubscription = changes[
        "seekPlayerToTime"
      ].currentValue.subscribe((timeMs) => {
        this.getVideoElement().currentTime = timeMs / 1000;
      });
    }
    if (!changes["videoUrl"]) {
      return;
    }

    this.resetComponent();
  }

  /**
   * On Loading Start
   * @param event
   * @return void
   */
  onLoadingStart(event) {
    if (this.timer == null) {
      this.timer = window.setTimeout(() => {
        this.slowConnection = true;
        this.changeDetectorRef.markForCheck();
      }, 15000); // 10 Seconds
    }
  }

  /**
   * loading event handler
   * @param event
   */
  onLoading(event) {
    const ranges: TimeRanges = event.target.buffered;

    if (ranges.length > 0) {
      // console.info("Ranges: ", ranges);
      // console.log("Loading: ", ranges.start(0) , " - " y, ranges.end(0));
    }
  }

  /**
   * Failed to Play the video handler
   * @param event
   */
  onError(event) {
    if (!this.videoUrl) {
      return;
    }

    this.isError = true;
    console.error(
      "There's an error: ",
      event.target.error ? "code " + event.target.error.code : "",
    );
  }

  /**
   * Listener to video make is ready when can play it
   * @param event
   * @return void
   */
  onCanPlay(event) {
    this.ready = true;
    if (this.media) {
      this.duringRecording = this.media.duringRecording;
    }
    this.changeDetectorRef.markForCheck();

    setTimeout(function () {
      document.querySelector("#play")["focus"]();
    }, 300);
  }

  onTimeupdate(event) {
    if (this.getVideoElement() == null) {
      return;
    }
    if (this.getVideoElement().currentTime === 0) {
      return;
    }
    console.log(
      "this.getVideoElement().currentTime",
      this.getVideoElement().currentTime,
      event,
    );
    this.calculateCurrentTime(
      this.getVideoElement().currentTime,
      this.getVideoElement().duration,
    );
  }

  /**
   * Selecting Audio File
   * @param audio
   */
  onSelectAudio(audio: Audio) {
    /* back to default */
    if (audio.playDefault) {
      this.playDefaultAudioTrack();
      this.audioOpen = false;
      return;
    }

    if (!audio.url) {
      if (this.playing) {
        this.getVideoElement().pause();
        this.autoStopForAudioSync = true;
        this.changeDetectorRef.markForCheck();
      }

      this.audioRepository.getAudioURL(audio.id).then((audio) => {
        this.getAudioElement().src = audio.url;
        this.shouldPlayAudioTrack = true;

        if (this.autoStopForAudioSync) {
          this.syncAudioTrack();
        }
      });
    }

    this.audioOpen = false;
  }

  /**
   * dispatched by browser (when audio track element is ready)
   * @param event
   */
  onAudioTrackReady(event) {
    if (this.autoStopForAudioSync) {
      setTimeout(() => {
        this.getVideoElement().play();
      }, 500);
      this.autoStopForAudioSync = false;
    }
  }

  /**
   * play audio track and mute default audio track
   * @return void
   */
  playAudioTrack() {
    this.getAudioElement().muted = false;
    this.getAudioElement().volume = 1.0;

    this.getVideoElement().muted = true;

    this.getAudioElement().play();
  }

  /**
   * sync video timing with audio track timing
   * @return VideoContainerComponent
   */
  syncAudioTrack(): VideoContainerComponent {
    this.getAudioElement().currentTime = this.getVideoElement().currentTime;
    return this;
  }

  /**
   * dispatched when audio track needs to stop (usually when user click on pause)
   * @return void
   */
  stopAudioTrack() {
    this.getAudioElement().pause();
  }

  /**
   * play default audio track
   * @return void
   */
  playDefaultAudioTrack() {
    this.shouldPlayAudioTrack = false;
    this.stopAudioTrack();

    this.muted = true;
    this.muteToggle();

    this.changeDetectorRef.markForCheck();
  }

  /**
   * When user select a subtitle
   * @param subtitle
   * @return void
   */
  onSelectSubtitle(subtitle: Subtitle) {
    this.selectedSubtitle = subtitle;
    this.subtitlesStyle = {};
    /* STUB - ADD PLAYBACK SPEED AND OFFSET TO SUBTITLE */
    // this.selectedSubtitle.playbackSpeed = (25.0 / 23.976);
    // this.selectedSubtitle.offset = 0;

    (async () => {
      if (this.channelInfo) {
        let fontId;
        let startPosition, endPosition;
        if (
          this.channelInfo.burnSubtitles &&
          this.channelInfo.subtitleLanguage === subtitle.language
        ) {
          fontId = this.channelInfo.subtitleFontSettings.fontId;
          startPosition =
            this.channelInfo.subtitleFontSettings.subtitleStartPositionFromTop;
          endPosition =
            this.channelInfo.subtitleFontSettings.subtitleEndPositionFromTop;
        } else {
          this.channelInfo.platforms.some((p) => {
            if (p.channelPlatformType === ChannelPlatformType.Custom) {
              const subtitleData = (p as CustomChannelPlatform).dvbSubtitles[
                subtitle.language
              ];
              if (subtitleData) {
                fontId = subtitleData.fontId;
                startPosition = subtitleData.subtitleStartPositionFromTop;
                endPosition = subtitleData.subtitleEndPositionFromTop;
                return true;
              }
            }
          });
        }

        if (fontId) {
          this.httpService
            .get(`Font/${fontId}/GetFontUrl`)
            .then((result: any) => {
              if (result) {
                const fontFamily = `subtitles-font-${fontId}`;
                let fontSize;
                // append style tag with font-face
                const style = document.createElement("style");
                fontSize = (endPosition - startPosition) * 6.66667; // 15% equals 100
                if (this.isFullScreen) {
                  fontSize = fontSize * 3; // scale to full screen
                }
                style.innerHTML = `@font-face{ font-family: ${fontFamily}; src:url('${result}'); }`;
                document.head.appendChild(style);
                // set subtitles style
                this.subtitlesStyle = {
                  top: startPosition + "%",
                  "font-family": fontFamily + ", Sans-Serif",
                  "font-size": fontSize + "%",
                };
                // this.changeDetectorRef.markForCheck();
              }
            });
        } else {
          this.adjustSubtitleFontSize();
        }
      }
    })();

    /* Always fetch a fresh presigned URL — both subtitle and closed-caption
       JSON live in a private bucket, so a direct GET of the stored url 401s. */
    this.subtitleRepository
      .getSubtitleURL(subtitle.id)
      .then((signed) => this.downloadSubtitles(signed.url))
      .then((data) => {
        this.subtitle = this._handleMultipartsSubs(data);
        this.prepareSubtitleElement();
      })
      .catch((err) =>
        console.error("video-container->onSelectSubtitle download failed", err),
      );
    this.subtitlesOpen = false;
  }

  /**
   * Searching for the first entry
   * @return Subtitle
   */
  getSubtitleEntry(currentTime: number) {
    /* Validate Subtitle Index */
    if (!this.subtitle || !this.subtitle["Subs"]?.[this.subtitleIndex]) {
      return;
    }

    /* Fetching the parts */
    const subtitleDetails = this.subtitle["Subs"][this.subtitleIndex];
    let subtitle = null;

    /* Check if current time is in range of subtitles */
    const subtitleStartTime = this.toDecimal(subtitleDetails["StartTimeMS"]);
    const subtitleEndTime = this.toDecimal(subtitleDetails["EndTimeMS"]);
    if (
      this.isSubtitleInRange(currentTime, subtitleStartTime, subtitleEndTime)
    ) {
      /* Getting the subtitle */
      subtitle = subtitleDetails["Text"];
    }

    return subtitle;
  }

  /**
   * Return boolean value whether the subtitle should be displayed
   * @param currentTime
   * @param startTime
   * @param endTime
   * @return boolean
   */
  isSubtitleInRange(currentTime, startTime, endTime) {
    /* subtitle start time and end time fix */
    if (
      this.selectedSubtitle.playbackSpeed &&
      this.selectedSubtitle.playbackSpeed > 0
    ) {
      startTime =
        startTime / this.selectedSubtitle.playbackSpeed +
        this.selectedSubtitle.offset;
      endTime =
        endTime / this.selectedSubtitle.playbackSpeed +
        this.selectedSubtitle.offset;
    }

    if (currentTime >= startTime) {
      if (currentTime <= endTime) {
        return true;
      }

      this.subtitleIndex++;
    }

    return false;
  }

  /**
   * Prepare Subtitle Element (First item should be presented accoding to time)
   * @return void
   */
  prepareSubtitleElement() {
    if (!this.subtitle) {
      return;
    }

    /* change rtl direction — closed-caption JSON has no top-level Language,
       so fall back to the selected track's own language. */
    const subtitleLanguage =
      this.subtitle.Language || this.selectedSubtitle?.language;
    this.rtlSubtitle =
      subtitleLanguage && RTL_SUBTITLES[subtitleLanguage.toLowerCase()]
        ? true
        : false;
    if (this.rtlSubtitle) {
      this.convertSubtitleToLogicalIfNeeded();
    }

    const currentTime = parseInt(this.getVideoElement().currentTime.toString());

    /* if current time is bigger than 0 */
    if (currentTime > 0) {
      const subtitleTime = currentTime + this.toDecimal(this.subtitleOffsetMs);
      this.subtitleIndex = this.getFirstSubtitleIndex(subtitleTime);
      console.log(
        `video-container->subtitleIndex: ${this.subtitleIndex}, currentTime: ${currentTime}, subtitleTime: ${subtitleTime}, text: ${this.subtitle["Subs"]?.[this.subtitleIndex]?.["Text"]}`,
      );
      return;
    }

    this.subtitleIndex = 0;
  }
  private _handleMultipartsSubs(subEntry: any): any {
    if (subEntry && subEntry["Subs"]) {
      //Handle Multiparts subs
      const existingSubs = subEntry["Subs"];
      const updatedSubs = [];
      let prevSubEntry;
      for (let i = 0; i < existingSubs.length; i++) {
        const currentSubEntry = existingSubs[i];
        if (currentSubEntry["HasMoreParts"]) {
          prevSubEntry = currentSubEntry;
          continue;
        } else if (
          prevSubEntry &&
          this._checkIfSameTime(prevSubEntry, currentSubEntry)
        ) {
          currentSubEntry["Text"] =
            prevSubEntry["Text"] + "\r\n" + currentSubEntry["Text"];
        }

        updatedSubs.push(currentSubEntry);
        prevSubEntry = currentSubEntry;
      }

      console.log(
        "video-container->prepareSubtitleElement-> handle multiparts->",
        subEntry["Subs"],
        updatedSubs,
      );
      subEntry["Subs"] = updatedSubs;
    }

    return subEntry;
  }
  private _checkIfSameTime(sub1: any, sub2: any): boolean {
    return (
      sub1["StartTimeMS"] === sub2["StartTimeMS"] &&
      sub1["EndTimeMS"] === sub2["EndTimeMS"]
    );
  }

  /**
   * Convert selected subtitle to logical from semi-logical
   * "Cavena RTL subs detected"
   * @return void
   */
  convertSubtitleToLogicalIfNeeded() {
    let punctAtStart = 0;
    let punctAtEnd = 0;

    if (this.subtitle && this.subtitle["Subs"]) {
      this.subtitle["Subs"].forEach((sub: string, index: number) => {
        const lines = sub["Text"].split("\n");

        lines.forEach((line: string) => {
          const cleanLine: string = line.replace("\r", "");

          if (
            cleanLine.startsWith(".") ||
            cleanLine.startsWith(",") ||
            cleanLine.startsWith("!") ||
            cleanLine.startsWith("?") ||
            cleanLine.startsWith(":") ||
            cleanLine.startsWith(";") ||
            cleanLine.startsWith("-") ||
            cleanLine.startsWith(" ")
          ) {
            punctAtStart++;
          }

          if (
            cleanLine.endsWith(".") ||
            cleanLine.endsWith(",") ||
            cleanLine.endsWith("!") ||
            cleanLine.endsWith("?") ||
            cleanLine.endsWith(":") ||
            cleanLine.endsWith(";") ||
            cleanLine.endsWith("-") ||
            cleanLine.endsWith(" ")
          ) {
            punctAtEnd++;
          }
        });
      });
    }

    if (punctAtStart < punctAtEnd) {
      return;
    }

    const punctuations = `.,!?:; -()"`;

    if (this.subtitle && this.subtitle["Subs"]) {
      this.subtitle["Subs"].forEach((sub: string, index: number) => {
        const lines = sub["Text"].split("\n");

        lines.forEach((line: string, lineIndex: number) => {
          if (!this.validateLineIsRTL(line)) {
            return;
          }
          let cleanLine: string = line.replace("\r", "");

          let prefix = "";
          let suffix = "";

          /* skip line if empty */
          if (cleanLine.length === 0) {
            return;
          }

          /* handle prefix */
          while (
            cleanLine.length > 0 &&
            punctuations.includes(cleanLine.substr(0, 1))
          ) {
            prefix = cleanLine.substr(0, 1).concat(prefix);
            cleanLine = cleanLine.substr(1);
          }

          /* handle suffix */
          while (
            cleanLine.length > 0 &&
            punctuations.includes(cleanLine.substr(-1))
          ) {
            suffix = suffix.concat(cleanLine.substr(-1));
            cleanLine = cleanLine.substr(0, cleanLine.length - 1);
          }

          /* fix 45:11 to 11:45 and fix reversed rounded brackets */
          const cleanChars = cleanLine.split("");
          const originChars = cleanLine.split("");

          for (let charIndex = 0; charIndex < cleanChars.length; charIndex++) {
            /* fix reversed rounded brackets */
            if (cleanChars[charIndex] === "(") {
              cleanChars[charIndex] = ")";
            } else if (cleanChars[charIndex] === ")") {
              cleanChars[charIndex] = "(";
            }

            /* */
            if (charIndex > 0 && charIndex < cleanChars.length - 1) {
              if (
                cleanChars[charIndex] === ":" &&
                cleanChars[charIndex - 1] >= "0" &&
                cleanChars[charIndex - 1] <= "9" &&
                cleanChars[charIndex + 1] >= "0" &&
                cleanChars[charIndex + 1] <= "9"
              ) {
                let firstNum = charIndex - 1;

                while (
                  firstNum > 0 &&
                  cleanChars[firstNum - 1] >= "0" &&
                  cleanChars[firstNum - 1] <= "9"
                ) {
                  firstNum--;
                }

                let lastNum = charIndex + 1;

                while (
                  lastNum < cleanChars.length - 1 &&
                  cleanChars[lastNum + 1] >= "0" &&
                  cleanChars[lastNum + 1] <= "9"
                ) {
                  lastNum++;
                }

                let ptr = firstNum;

                for (let index = charIndex + 1; index <= lastNum; index++) {
                  cleanChars[ptr++] = originChars[index];
                }

                cleanChars[ptr++] = ":";

                for (let index = firstNum; index < charIndex; index++) {
                  cleanChars[ptr++] = originChars[index];
                }
              }
            }
          }

          cleanLine = cleanChars.join("");

          lines[lineIndex] = suffix.concat(cleanLine).concat(prefix);
        });

        this.subtitle["Subs"][index]["Text"] = lines.join("\r\n");
      });
    }
  }

  /**
   *
   * @param {string} line - line to analyze
   * @return {boolean}
   */

  validateLineIsRTL(line: string) {
    for (let i = 0; i < line.length; i++) {
      if (PUNCATUATIONS.indexOf(line[i]) === -1) {
        return HE_LETTERS.indexOf(line[i]) > -1 ||
          AR_LETTERS.indexOf(line[i]) > -1
          ? true
          : false;
      }
    }
  }

  /**
   *
   * @param currentTime
   * @param subtitles
   * @param lastIndex
   * @return {any}
   */
  getFirstSubtitleIndex(currentTime: number) {
    const subs = this.subtitle["Subs"];
    if (!subs || subs.length === 0) {
      return 0;
    }

    let startPoint = 0;
    let endPoint = subs.length;

    let length = endPoint - startPoint;

    while (length > 1) {
      /* */
      const midPoint = parseInt((length / 2).toString()) + startPoint;
      const midPointTime = this.toDecimal(subs[midPoint]["StartTimeMS"]);
      if (currentTime > midPointTime) {
        console.log(
          `video-container->getFirstSubtitleIndex-> currentTime: ${currentTime}, midpoint time: ${midPointTime}`,
        );
        startPoint = midPoint;
      } else {
        endPoint = midPoint;
      }

      length = endPoint - startPoint;
    }
    const nextSub = subs[startPoint + 1];
    console.log(
      `video-container->getFirstSubtitleIndex-> result: currentTime: ${currentTime}, midpoint time: ${this.toDecimal(subs[startPoint]["StartTimeMS"])}, nextTime: ${nextSub ? this.toDecimal(nextSub["StartTimeMS"]) : "none"}`,
    );
    return startPoint;
  }

  /**
   * Converting miliseconds to decimal
   * @param msTime
   * @return double
   */
  toDecimal(msTime) {
    return msTime / 1000.0;
  }

  /**
   * Calculating Visual Time According to Bar based on Video Current Time and Total Duration
   * Calculating to percent that passed
   * @param videoCurrentTime
   * @param duration
   */
  calculateCurrentTime(videoCurrentTime, duration) {
    this.duration = Math.round((videoCurrentTime / duration) * 100);
    this.currentTimeMsChange.next(videoCurrentTime * 1000);
    this.timecodeValue = videoCurrentTime * 1000;
  }

  /**
   * on Play dispatcher
   * @param event
   * @return void
   */
  onPlay(event) {
    this.playing = true;
    this.request = true;

    if (this.shouldPlayAudioTrack) {
      this.playAudioTrack();
    }

    window.requestAnimationFrame(this.subtitleViewHandler.bind(this));
    this.timecodeInterval = setInterval(() => {
      //this.timecodeValue = this.getVideoElement().currentTime;
    }, 1);
  }

  /**
   * Fetch and display subtitle
   * @param timestamp
   */
  async subtitleViewHandler(timestamp) {
    if (!this.lastTime) {
      this.lastTime = timestamp;
    }

    /* Calculate for Milliseconds [Original x.xx] */
    const currentTime = this.getVideoElement().currentTime;
    const subtitleTime = currentTime + this.toDecimal(this.subtitleOffsetMs);

    let subtitle: string = this.getSubtitleEntry(subtitleTime);
    //console.log(`video-container-> subtitleTime: ${subtitleTime}, currentTime: ${currentTime}, subtitleOffsetMs: ${this.subtitleOffsetMs}, selectedSubtitleIndex: ${this.subtitleIndex}, subtitle: ${subtitle}`);

    if (subtitle) {
      subtitle = subtitle.replace(/(?:\r\n|\r|\n)/g, "<br />");
      subtitle = subtitle.replace(/(?:{\\an\d})/g, "");
    }

    /* Assign value */
    this.subtitleText = this.sanitizer.bypassSecurityTrustHtml(
      typeof subtitle === "string" ? subtitle : "",
    );

    this.changeDetectorRef.markForCheck();
    if (this.request) {
      window.requestAnimationFrame(this.subtitleViewHandler.bind(this));
    }
  }

  /**
   * on Pause dispatcher
   * @param event
   */
  onPause() {
    this.playing = false;
    this.request = false;

    this.stopAudioTrack();
    if (this.timecodeInterval) {
      clearInterval(this.timecodeInterval);
      this.timecodeInterval = null;
    }
  }

  /**
   * Dispatch when user click on "Play" / "Pause" Button
   * @param event
   * @return void
   */
  playToggle(event?) {
    if (this.getVideoElement().paused) {
      this.syncAudioTrack();
      this.getVideoElement().play();
      return;
    }

    this.getVideoElement().pause();
  }

  /**
   * Mute or unmute player
   * @param event
   * @return void
   */
  muteToggle(event?) {
    this.muted = !this.muted;

    this.getVideoElement().muted = this.muted
      ? true
      : this.shouldPlayAudioTrack
        ? true
        : false;
    this.getAudioElement().muted = this.muted ? true : false;
  }

  /**
   * Audio Toggle Handler
   * @param event
   * @return void
   */
  audioToggle(event) {
    this.audioOpen = !this.audioOpen;

    /* Turning of the subtitles */
    if (this.audioOpen) {
      this.subtitlesOpen = this.timecodeFormatOpen = false;
    }

    this.onVideoOptions = this.audio;
  }

  /**
   * Subtitles toggle handler (Open / Close)
   * @param event
   * @return void
   */
  subtitlesToggle(event) {
    this.subtitlesOpen = !this.subtitlesOpen;

    /* Turning off audio option */
    if (this.subtitlesOpen) {
      this.audioOpen = this.timecodeFormatOpen = false;
    }

    /* Keep the active track highlighted (its radio dot) across reopens —
       the menu is rebuilt every time it opens, so re-derive `selected`. */
    const selectedName = this.selectedSubtitle?.name;
    const subtitleOptions = (this.subtitles || []).map((s) => {
      const name = `${s.language} [SUB]`;
      return { ...s, name, selected: name === selectedName };
    });
    const closedCaptionOptions = (this.closedCaptions || []).map((c) => {
      const name = `${c.flavoredLabel} [CC]`;
      return { ...c, name, selected: name === selectedName };
    });
    this.onVideoOptions = [...subtitleOptions, ...closedCaptionOptions];
  }

  /**
   * Notify when selection triggered
   * @param value
   * @return void
   */
  onSelectVideoOption(value: any) {
    if (this.subtitlesOpen) {
      return this.onSelectSubtitle(value);
    }
    if (this.timecodeFormatOpen) {
      return this.onSelectTimecodeFormat(value);
    }
    if (this.audioOpen) {
      return this.onSelectAudio(value);
    }
  }

  /**
   * Downloading the Subtitle
   * @param url
   * @return {Promise<string>}
   */
  downloadSubtitles(url) {
    return this.subtitleRepository.downloadSubtitle(url);
  }

  /**
   * Make video full screen
   * @return void
   */
  fullScreen() {
    if (this.isFullScreen) {
      (document as any).webkitExitFullscreen();
    } else {
      /* Getting the new element and request full screen */
      const videoElm = this.getVideoElementForFullScreen();

      if (videoElm.requestFullscreen) {
        videoElm.requestFullscreen();
      }

      if (videoElm.webkitRequestFullScreen) {
        videoElm.webkitRequestFullScreen();
      }

      // if (this.playing) videoElm.play();
    }
  }

  adjustSubtitleFontSize() {
    let size;
    if (!this.subtitlesStyle) {
      return;
    }
    if (this.subtitlesStyle["font-size"]) {
      size = Number(this.subtitlesStyle["font-size"].slice(0, -1));
      if (this.isFullScreen) {
        size = size * 3;
      } else {
        size = size / 3;
      }
    } else {
      size = this.isFullScreen ? 300 : 100;
    }
    this.subtitlesStyle["font-size"] = size + "%";
  }

  /**
   * On Full Screen Changed
   * @param event
   */
  onFullScreenChangedListener(event) {
    event.stopPropagation();
    this.isFullScreen = !this.isFullScreen;
    this.changeDetectorRef.markForCheck();
    this.adjustSubtitleFontSize();
    /* Validate current element as full screen */
    if (!this.isFullScreen) {
      return;
    }

    /* Support Chrome Only */
    if (!(document as any).webkitIsFullScreen) {
      this.calculateCurrentTime(
        event.target["currentTime"],
        event.target["duration"],
      );

      /* Manipulate DOM */
      this.element.nativeElement.appendChild(event.target);
      event.target.classList.remove("full-screen-video");

      if (this.playing) {
        this.getVideoElement().play();
      }
    }
  }

  getVideoElementForFullScreen() {
    return this.element.nativeElement.querySelector(
      "#videoContainerComponentId",
    );
  }
  /**
   * Getting the Native Video Tag
   * @returns {HTMLElement|Element}
   */
  getVideoElement(): HTMLVideoElement {
    return this.element.nativeElement.querySelector("video");
  }

  /**
   * return the attached audio tag element
   * @return HTMLAudioElement
   */
  getAudioElement(): HTMLAudioElement {
    return this.audioTrack.nativeElement;
  }

  onTrimInBracketMove(event) {
    const deltaMove = this.trimInDragPosition - event.pageX;
    const deltaMoveMilliseconds =
      (deltaMove / this.durationProgressBarWidthPx) * this.mediaDurationMs * -1;
    let newTrimInMs: any = this.trimInMs;

    if (deltaMoveMilliseconds > 0) {
      const nextMoveMs = this.trimInMs + Math.abs(deltaMoveMilliseconds);
      if (nextMoveMs < this.mediaDurationMs && newTrimInMs < this.trimOutMs) {
        newTrimInMs = nextMoveMs;
        //console.log('moving right', newTrimInMs);
      }
    } else {
      //console.log('moving left', event);
      const nextMoveMs = this.trimInMs - Math.abs(deltaMoveMilliseconds);
      if (nextMoveMs > 0) {
        newTrimInMs = nextMoveMs;
      } else {
        newTrimInMs = 0;
      }
    }
    const trimInWidth =
      (this.trimInMs / this.mediaDurationMs) * this.durationProgressBarWidthPx;
    this.durationTooltipX = trimInWidth - this.durationTooltipWidth / 2;
    this.overDurationTxt =
      (newTrimInMs / this.mediaDurationMs) * this.getVideoElement().duration;

    this.changeDetectorRef.markForCheck();

    this.trimInMsChange.emit(parseInt(newTrimInMs));
    this.trimInDragPosition = event.pageX;

    event.preventDefault();
  }

  onTrimInMouseDown(event) {
    this.trimInDragPosition = event.pageX;
    const document = (event.target as any).ownerDocument;
    this._trimInMouseUp = this.onTrimInMouseUp.bind(this);
    this._trimInMouseMove = this.onTrimInBracketMove.bind(this);

    this.whileTrimming = true;
    this.durationTooltipVisible = true;
    document.addEventListener("mousemove", this._trimInMouseMove);
    document.addEventListener("mouseup", this._trimInMouseUp);
  }

  onTrimInMouseUp(event) {
    document.removeEventListener("mousemove", this._trimInMouseMove);
    document.removeEventListener("mouseup", this._trimInMouseUp);
    this.durationTooltipVisible = false;
    this.whileTrimming = false;
  }

  onTrimOutMouseDown(event) {
    this.trimOutDragPosition = event.pageX;
    const document = (event.target as any).ownerDocument;
    this._trimOutMouseUp = this.onTrimOutMouseUp.bind(this);
    this._trimOutMouseMove = this.onTrimOutBracketMove.bind(this);

    this.whileTrimming = true;
    this.durationTooltipVisible = true;

    document.addEventListener("mousemove", this._trimOutMouseMove);
    document.addEventListener("mouseup", this._trimOutMouseUp);
  }

  onTrimOutMouseUp(event) {
    document.removeEventListener("mousemove", this._trimOutMouseMove);
    document.removeEventListener("mouseup", this._trimOutMouseUp);
    this.durationTooltipVisible = false;
    this.whileTrimming = false;
  }

  onTrimOutBracketMove(event) {
    //console.log('onTrimOutBracketMove', event);
    const deltaMove = this.trimOutDragPosition - event.pageX;
    const deltaMoveMilliseconds =
      (deltaMove / this.durationProgressBarWidthPx) * this.mediaDurationMs * -1;
    let newTrimOutMs: any = this.trimOutMs;

    if (deltaMoveMilliseconds > 0) {
      const nextMoveMs = this.trimOutMs + Math.abs(deltaMoveMilliseconds);
      if (nextMoveMs <= this.mediaDurationMs) {
        newTrimOutMs = nextMoveMs;
        //console.log('moving right', newTrimOutMs);
      } else {
        newTrimOutMs = this.mediaDurationMs;
      }
    } else {
      //console.log('moving left', newTrimOutMs);
      const nextMoveMs = this.trimOutMs - Math.abs(deltaMoveMilliseconds);
      if (nextMoveMs > 0 && nextMoveMs > this.trimInMs) {
        newTrimOutMs = nextMoveMs;
      }
    }
    const trimOutWidth =
      (this.trimOutMs / this.mediaDurationMs) * this.durationProgressBarWidthPx;
    this.durationTooltipX = trimOutWidth - this.durationTooltipWidth / 2;
    this.overDurationTxt =
      (newTrimOutMs / this.mediaDurationMs) * this.getVideoElement().duration;
    this.changeDetectorRef.markForCheck();

    this.trimOutMsChange.emit(parseInt(newTrimOutMs));
    this.trimOutDragPosition = event.pageX;
    event.preventDefault();
  }

  onTrimMouseEnter($event: MouseEvent) {
    this.durationTooltipVisible = false;
    this.changeDetectorRef.markForCheck();

    return false;
  }

  /**
   * Reset Component
   * @return void
   */
  resetComponent() {
    this.ready = false;
    this.duration = 0;
    this.currentTimeMsChange.next(0);
    this.muted = false;
    this.subtitleIndex = undefined;
    this.subtitle = undefined;
    this.isError = false;

    this.timer = null;
    this.slowConnection = false;
    //this.showTimecode = this.checkIfHlsFormat();
    /* audio */
    this.shouldPlayAudioTrack = false;

    this.onPause();

    if (this.getVideoElement()) {
      this.getVideoElement().pause();
    }

    /* subtitle fixes */
    this.defaultSubtitleLanguage = "EN";
    this.selectedSubtitle = null;

    this.changeDetectorRef.markForCheck();
  }

  /**
   * Seeking and moving forward / backwards according to user's click
   * @param event
   * @return void
   */
  seek(event) {
    if (!this.ready) {
      return;
    }

    /* Get the total width of the bar */
    const barTotalWidth =
      this.element.nativeElement.querySelector(".progress-bar i")[
        "clientWidth"
      ];

    /* Calculate Percent */
    const percent = (event["offsetX"] / barTotalWidth) * 100;

    /* Assign Visual Duration */
    this.duration = percent;
    this.currentTimeMsChange.next(this.getVideoElement().currentTime * 1000);

    /* Reset Subtitle */
    this.subtitleIndex = undefined;

    /* Change current time */
    this.getVideoElement().currentTime = this.timecodeValue =
      (this.getVideoElement().duration / 100) * percent;

    this.syncAudioTrack();

    this.prepareSubtitleElement();
    this.changeDetectorRef.markForCheck();
  }

  playTrimmed() {
    if (!this.ready) {
      return;
    }

    this.subtitleIndex = undefined;

    const videoElement = this.getVideoElement();
    videoElement.currentTime = this.trimInMs / 1000;

    this.syncAudioTrack();

    this.prepareSubtitleElement();
    this.getVideoElement().play();
    this.changeDetectorRef.markForCheck();
  }

  /**
   * Dispatched when video is ended
   * @param event
   * @return void
   */
  onEnded(event) {
    /* Reset Subtitle */
    this.subtitleIndex = undefined;
  }

  /**
   * Initializing the component
   * @return void
   */
  ngOnInit() {}

  ngAfterViewInit(): void {
    console.log("video url", this.videoUrl);
    this.resetComponent();
    /* Adding Listeners */
    ["", "webkit", "moz", "ms"].forEach((prefix) =>
      document.addEventListener(
        `${prefix}fullscreenchange`,
        this.onFullScreenChangedListener.bind(this),
        false,
      ),
    );
    const progressBar = this.durationElement.nativeElement;

    this.durationProgressBarWidthPx =
      this.durationElement.nativeElement["clientWidth"];

    if (this.showTrimBrackets) {
      this.updateTrimming();

      // @ts-ignore
      const duarionResizeObserver = new ResizeObserver((entries) => {
        this.durationProgressBarWidthPx =
          this.durationElement.nativeElement["clientWidth"];
        this.updateTrimming();
      });
      duarionResizeObserver.observe(progressBar);
    }
    /* Validate */
    if (progressBar) {
      progressBar.addEventListener(
        "mousemove",
        this.onMouseoverProgressBar.bind(this),
      );
      progressBar.addEventListener(
        "mouseenter",
        this.progressBarMouseEnterHandler.bind(this),
        false,
      );
      progressBar.addEventListener(
        "mouseleave",
        this.progressBarMouseLeaveHandler.bind(this),
        false,
      );
    }

    this.userService.getCurrentChannel().then((currentChannel) => {
      if (currentChannel) {
        this.channelRepository
          .getChannelInfoById(currentChannel.id)
          .then((ci) => {
            this.channelInfo = ci;
            this.timecodeFormatting = this.channelInfo.framerate ? "fps" : "ms";
          });
      }
    });
    // this.reference = this.onKeyup.bind(this);
    // this.element.nativeElement.addEventListener("keydown", this.reference, false);
    this.calculateFrameDuration();
  }

  private updateTrimming() {
    const trimInWidth =
      (this.trimInMs / this.mediaDurationMs) * this.durationProgressBarWidthPx -
      this.trimBracketWidth / 2;
    const trimOutWidth =
      (this.trimOutMs / this.mediaDurationMs) *
        this.durationProgressBarWidthPx -
      this.trimBracketWidth -
      this.trimBracketWidth / 2;

    this.calculatedTrinInOffset = trimInWidth;
    this.calculatedTrinOutOffset = trimOutWidth;

    this.changeDetectorRef.markForCheck();
  }
  calculateFrameDuration(): any {
    if (this.framerate > 0) {
      this.frameDuration = 1000 / this.framerate / 1000;
    }
  }
  /**
   * remove listener if needed
   * @return void
   */
  ngOnDestroy() {
    if (this.seekPlayerToTimeSubscription) {
      this.seekPlayerToTimeSubscription.unsubscribe();
    }
    // this.element.nativeElement.removeEventListener("keydown", this.reference, false);
  }

  /**
   * when user click on key up and down
   * @param event
   */
  @HostListener("keydown", ["$event"])
  onKeydown(event: KeyboardEvent) {
    if (!this.playing && this.frameDuration > 0) {
      const elm = this.getVideoElement();
      let newCurrentTime = elm.currentTime;
      if (event.code === "ArrowLeft") {
        if (newCurrentTime < this.frameDuration) {
          newCurrentTime = 0;
        } else {
          newCurrentTime -= this.frameDuration;
        }
      } else if (event.code === "ArrowRight") {
        if (elm.duration - newCurrentTime < this.frameDuration) {
          newCurrentTime = elm.duration;
        } else {
          newCurrentTime += this.frameDuration;
        }
      }
      elm.currentTime = this.timecodeValue = newCurrentTime;
    } else {
      const step = event.shiftKey ? 30 : 10;
      /* arrow left */
      if (event.code === "ArrowLeft") {
        if (this.getVideoElement().currentTime < step) {
          this.getVideoElement().currentTime = 0;
        } else {
          this.getVideoElement().currentTime =
            this.getVideoElement().currentTime - step;
        }
      }

      if (event.code === "ArrowRight") {
        if (
          this.getVideoElement().duration - this.getVideoElement().currentTime <
          step
        ) {
          this.getVideoElement().currentTime = this.getVideoElement().duration;
        } else {
          this.getVideoElement().currentTime =
            this.getVideoElement().currentTime + step;
        }
      }
    }
    if (event.code === "Escape") {
      if (this.isFullScreen) {
        this.isFullScreen = false;
      }
    }
  }

  /**
   * Handler for on mouse hover
   * @param event
   */
  onMouseoverProgressBar(event) {
    /* Get the total width of the bar */
    const barTotalWidth =
      this.element.nativeElement.querySelector(".progress-bar i")[
        "clientWidth"
      ];

    /* Calculate Percent */
    const percent = (event["layerX"] / barTotalWidth) * 100;

    /* calculate time for duration rule */
    this.overDuration = parseFloat(percent.toFixed(2)) / 100;
    if (this.overDuration < 0) {
      this.overDuration = 0;
    }

    this.overDurationRule = `scale(${this.overDuration}, 1)`;

    /* calculate time for hover */
    this.overDurationTxt =
      (this.getVideoElement().duration * parseFloat(percent.toFixed(2))) / 100;

    if (this.durationTooltipWidth == null) {
      this.durationTooltipWidth = parseInt(
        getComputedStyle(this.durationTooltip.nativeElement).width,
      );
    }

    /* changing duration position */
    if (this.whileTrimming === false) {
      this.durationTooltipX =
        this.overDuration - this.durationTooltipWidth / 2 + event["layerX"];
    }

    //console.log("progres mouse over");
    this.changeDetectorRef.markForCheck();
  }

  checkIfHlsFormat(): boolean {
    return (
      this.videoUrl &&
      this.videoUrl.length > 0 &&
      this.videoUrl &&
      this.videoUrl.includes(".m3u8")
    );
  }
  timecodeFormatToggle(event) {
    this.timecodeFormatOpen = !this.timecodeFormatOpen;

    /* Turning off audio option */
    if (this.timecodeFormatOpen) {
      this.audioOpen = this.subtitlesOpen = false;
    }

    this.onVideoOptions = [
      { name: "ms", selected: this.timecodeFormatting === "ms" },
      { name: "fps", selected: this.timecodeFormatting === "fps" },
    ];
  }
  onSelectTimecodeFormat(selected) {
    if (selected.name) {
      this.timecodeFormatting = selected.name;
    }
  }

  progressBarMouseEnterHandler($event: MouseEvent) {
    console.log("progressBarMouseEnterHandler");
    this.durationTooltipVisible = this.whileTrimming || true;
    this.changeDetectorRef.markForCheck();
  }

  progressBarMouseLeaveHandler($event: MouseEvent) {
    console.log("progressBarMouseLeaveHandler");
    this.durationTooltipVisible = this.whileTrimming || false;
    this.changeDetectorRef.markForCheck();
  }
}
